import { ApiService } from '../../../services/api_service';
import { checkKennzahlenPlausibel } from './routinen/checkKennzahlenPlausibel';
import { DataService } from '../../../services/data_service';
import { filterMethodFulltext } from '../../../core/forms/helpers/filter_method_fulltext';
import { fn2 } from '../../../core/formatter/formatNumber';
import { IDs } from '../../../helpers/IDs';
import { importRow } from './routinen/importRow';
import { KennzahlenImportEToolDialog } from './KennzahlenImportEToolDialog';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface KennzahlenImportEToolProps {
    data: any;
}

export interface KennzahlenImportEToolState {
    importRow: any;
    arrUnverarbeitet: any[];
    arrTodo: any[];
    additionalCheck: boolean;
}

export class KennzahlenImportETool extends React.Component<KennzahlenImportEToolProps, KennzahlenImportEToolState> {
    constructor(props: any) {
        super(props);
        this.state = {
            importRow: undefined,
            arrUnverarbeitet: undefined,
            arrTodo: [],
            additionalCheck: false
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private values: any;

    reset(): void {
        this.apiService.call('resetKennzahlenDatenbank', {}, (data: string, succ: boolean) => {
            if (succ) {
                this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
                this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL);
                this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION);
                alert('Die Kennzahlendatenbank wurde zurückgesetzt. Bitte die Aggregation manuell ausführen.');
            }
        }, IDs.MOD_ETOOL_ADMIN);
    }

    verarbeite(): void {
        const arrTodo = this.state.arrTodo;
        if (arrTodo && arrTodo.length > 0) {
            const next = arrTodo[0];
            const plausibel = checkKennzahlenPlausibel(next, this.props.data);
            if (plausibel.result || !this.state.additionalCheck) {
                importRow(next, this.props.data, this.dataService, undefined, (values: any) => {
                    arrTodo.splice(0, 1);
                    values = values || {};
                    this.values.del += values.del || 0;
                    this.values.save += values.save || 0;
                    this.setState({ arrTodo }, () => window.setTimeout(() => this.verarbeite(), 100));
                });
            } else {
                const status_item = { tid: next.tid, status: 3 };
                this.dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, status_item, undefined, false, (suc: boolean, saveTid: number) => {
                    arrTodo.splice(0, 1);
                    this.setState({ arrTodo }, () => window.setTimeout(() => this.verarbeite(), 100));
                }, IDs.MOD_ETOOL_ADMIN);
            }
        } else {
            this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
            alert(`Daten wurden importiert (${this.values.save} Datensätze)!${this.values.del ? `\nEs wurden ${this.values.del} Datensätze entfernt!` : ''}`);
        }
    }

    render(): JSX.Element {
        const customActions = [
            {
                label: 'Daten übernehmen',
                info: 'Daten übernehmen',
                key: 'config',
                func: (row: any) => this.setState({ importRow: row })
            },
            {
                label: 'Im E-Tool ansehen',
                info: 'Im E-Tool ansehen',
                key: 'show',
                func: (row: any) => {
                    const curUrl = new URL(window.location.href);
                    const url = curUrl.origin + curUrl.pathname.substring(0, curUrl.pathname.lastIndexOf('/') + 1);
                    // console.log(url);
                    const params = {
                        adminUser: this.apiService.getUsername(),
                        adminToken: this.apiService.getToken(),
                        mandantKey: row.mandant
                    };
                    // console.log(row, params, url);
                    const eToolPage = window.open(url)
                    const script = document.createElement('script');
                    script.innerHTML = 'parameter="' + window.btoa(JSON.stringify(params)) + '"';
                    eToolPage.document.body.appendChild(script);
                    eToolPage.focus();
                }
            }
        ];

        const customFormatter = (field: string, value: any, data?: any) => {
            if (field === 'daten') {
                let arr = null;
                try {
                    arr = JSON.parse(value);
                } catch (e) {
                    return <div style={{ color: 'red' }}> Datenfehler </div>;
                }
                const plausibel: any = checkKennzahlenPlausibel(data || {}, this.props.data) || {};
                const elements = arr.map((item: any) => {
                    const status_check = (plausibel[item.kuerzel] || {}).plausi_status;
                    let color: any = {};
                    // console.log('Item', item);
                    if (item.changed === false) {
                        color = { color: 'lightgrey' };
                    } else if (status_check === 'übersteuert') {
                        color = { color: 'blue' };
                    } else if (status_check !== 'ok') {
                        color = { color: 'red' };
                    }
                    return (<div>
                        <span style={{ width: 270, display: 'inline-block', ...color }}>
                            <b style={{ backgroundColor: item.allow ? '#7f7' : '', textDecoration: item.ignore ? 'line-through' : 'none' }}>
                                {item.name}:
                            </b>
                        </span>
                        <span style={{ width: 100, textAlign: 'right', display: 'inline-block', ...color }}>
                            {fn2(item.wert)}
                        </span>
                    </div>);
                });
                return <div>{elements}</div>;
            }
            if (field === 'status') {
                if (value === 1) {
                    value = <b>Importiert</b>;
                } else if (value === 2) {
                    value = <b>Abgelehnt</b>;
                } else if (value === 3) {
                    value = <b>Abgelehnt</b>;
                } else if (!value) {
                    value = <b>Unverarbeitet {value}</b>;
                }
            }

            return value;
        };
        const cntUnverarbeitet = this.state.arrUnverarbeitet ? this.state.arrUnverarbeitet.length : 0;
        const butAll = <WActionButton
            label='Alle übernehmen'
            insideText='Alle übernehmen'
            indicatorFullNumber={true}
            indicatorValue={cntUnverarbeitet}
            key='save'
            action='save'
            onAction={() => {
                const arrTodo = [...this.state.arrUnverarbeitet];
                if (confirm(`Wollen Sie alle Daten [${arrTodo.length}] übernehmen?`)) {
                    this.values = { del: 0, save: 0 };
                    this.setState({ arrTodo }, () => this.verarbeite());
                }
            }}
            disabled={!this.state.arrUnverarbeitet || this.state.arrUnverarbeitet.length === 0}
        />;
        const butReset = <WActionButton
            label='Initialzustand wiederherstellen'
            insideText='Initialzustand wiederherstellen'
            key='delete'
            action='delete'
            onAction={() => {
                if (confirm('Diese Funktion löscht alle aus den E-Tools gesammelten Daten in der zentralen Datenbank! Bitte bestätigen!')) {
                    if (confirm('Dieser Vorgang kann nicht Rückgängig gemacht werden! Wollen Sie wirklich fortfahren?')) {
                        this.reset();
                    }
                }
            }}
        />;
        const labelStyle = {
            cursor: 'pointer', display: 'flex', alignItems: 'center', height: 28, marginTop: 2, fontSize: 12,
            padding: '0 3px', backgroundColor: 'rgb(188, 202, 227)', marginRight: 2
        };
        const checkAdditional = <label style={labelStyle} key='label_test'>
            <input
                type='checkbox'
                checked={this.state.additionalCheck}
                onChange={(e: any) => this.setState({ additionalCheck: e.target.checked })}
            />
            Zu prüfende Datensätze filtern
        </label>;
        const customColumns: any[] = [
            {
                accessor: 'pruefung',
                Header: 'Prüfung' + (this.state.additionalCheck ? '' : ' (Nur Info)'),
                id: 'pruefung',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'pruefung')
            }
        ];

        return <>
            <WFormsTableWrapper
                entity={IDs.ENT_KENNZAHLEN_IMPORT}
                key={`kz_imp_${this.state.additionalCheck}`}
                module={IDs.MOD_ETOOL_ADMIN}
                onDataLoaded={(arr: any[]) => {
                    const arrUnverarbeitet = arr.filter((item: any) => {
                        //  console.log(item);
                        const res = checkKennzahlenPlausibel(item, this.props.data);
                        item.pruefung = res.result ? 'ok' :
                                            res.result_manual ? 'übersteuert' : 'prüfen';
                        // console.log('ARRI', item.status, this.state.additionalCheck, res.result,
                        //             (!item.status || item.staus === 3), (!this.state.additionalCheck || res.result));
                        return (!item.status || item.status === 3) && (!this.state.additionalCheck || res.result || res.result_manual);
                    });
                    // console.log('ARRU', arrUnverarbeitet.length);
                    this.setState({ arrUnverarbeitet });
                }}
                preFilterFunction={(data: any[]) => this.state.arrUnverarbeitet || []}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={[butAll, butReset, checkAdditional]}
                customClass='Custom-ETA'
                customColumns={customColumns}
                columnWidths={[100, 120, 120, 250, 50, , 400, 125, 75]}
                formLayout='flowV2'
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL)}
                showColumnsHelp={true}
                customActions={customActions}
                customFormatter={customFormatter}
            />
            {this.state.importRow &&
                <KennzahlenImportEToolDialog
                    importRow={this.state.importRow}
                    onClose={() => this.setState({ importRow: undefined })}
                    onSave={(data: any, callback: () => void) => {
                        this.setState({ importRow: data }, () => typeof callback === 'function' ? callback() : null);
                    }}
                    data={this.props.data}
                />}
            {(this.state.arrTodo && this.state.arrTodo.length > 0) && <WSpinner label={this.state.arrTodo.length + ''} />}
        </>;
    }
}
